import Page from './index';

export default { path: '/home/msgPush/bind', component: Page };
